import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingScreen } from "./LoadingIndicator";
import { useAuth } from "../contexts/AuthContext";
import { isAdmin } from "../utils/roleUtils";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen message="Loading your session..." />;
  }

  if (!user) {
    return <Navigate to={requireAdmin ? "/admin/login" : "/login"} replace state={{ from: location }} />;
  }

  if (requireAdmin && !isAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
